let redirect = {
  path: "/dashboard"
};

redirect["name"] = !localStorage.token ? "Company Login" : "Dashboard";

if (localStorage.active_user) {
  let object = JSON.parse(localStorage.active_user);
  if (object.role === 6) {
    let moduels =
      object.permissions || object.modules || object.company.modules || [];
    if (moduels.includes("track")) {
      redirect["name"] = "Dashboard";
    } else if (moduels.includes("historical")) {
      redirect["name"] = "Historical Visitors";
    } else if (moduels.includes("quick_code")) {
      redirect["name"] = "Quickpins List";
    } else if (moduels.includes("policy")) {
      redirect["name"] = "Policies";
    } else if (moduels.includes("resource")) {
      redirect["name"] = "Manage Resources";
    }
  }
}

export default redirect;
